import type { Place, RouteSuggestion } from '../types';

/** Normalize stops from a route suggestion into `Place` objects (shared by map, chat, cache warmup). */
export function placesFromRouteSuggestion(suggestion: RouteSuggestion): Place[] {
  const stops = suggestion.stops || suggestion.suggested_stops;
  if (!stops?.length) return [];
  return stops.map((stop, index) => {
    if ('place_id' in stop && 'name' in stop && 'location' in stop) {
      return stop as Place;
    }
    const latLngStop = stop as {
      lat: number;
      lng: number;
      name?: string;
      place_id?: string;
      type?: string;
      types?: string[];
      found_for_preference?: string;
      found_for_preferences?: string[];
      rating?: number;
      formatted_address?: string;
      photos?: Place['photos'];
    };
    return {
      place_id: latLngStop.place_id || `stop-${index}`,
      name: latLngStop.name || `Stop ${index + 1}`,
      location: { lat: latLngStop.lat, lng: latLngStop.lng },
      types: latLngStop.types || (latLngStop.type ? [latLngStop.type] : undefined),
      found_for_preference: latLngStop.found_for_preference,
      found_for_preferences: latLngStop.found_for_preferences,
      rating: latLngStop.rating,
      formatted_address: latLngStop.formatted_address,
      photos: latLngStop.photos,
    };
  });
}
